module.exports = __webpack_public_path__ + "img/JalilKakaWais.0704800e.jpg";